import * as React from 'react';
import { useMemo } from 'react';

import { Text, Toggle } from '@components/common';
import { useDisabledFeatures } from '@hooks/useDisabledFeatures';
import { VideoUrl } from '@lib/video-url/VideoUrl';

import { FieldRow } from '../components/FieldRow';

import type { BookingDetailsFormFieldComponentProps } from './types';

export const LiveStreamEnabled: React.FC<BookingDetailsFormFieldComponentProps> = ({
  bookingDetail,
  study,
  editMode,
  onChange
}) => {
  const value = bookingDetail.team_event?.live_stream_enabled;
  const { disabledFeatures } = useDisabledFeatures();
  const videoUrlType = bookingDetail.candidate_event?.provider;
  const videoUrl = new VideoUrl(bookingDetail.candidate_event?.location);

  const liveStreamAvailable = useMemo(() => {
    return (
      videoUrlType === 'zoom' ||
      videoUrlType === 'webex' ||
      videoUrlType === 'microsoft_teams' ||
      videoUrlType === 'google_meet' ||
      (videoUrlType === 'manual' && videoUrl.isSupported())
    );
  }, [videoUrlType, videoUrl]);

  const isDisabled = !liveStreamAvailable || study?.focus_group || disabledFeatures.livestream;

  return (
    <FieldRow label='Live stream?'>
      {!editMode && (
        <div className='overflow-auto py-2.5'>
          <Text h='400'>{value ? 'Enabled' : 'Disabled'}</Text>
        </div>
      )}
      {editMode && (
        <div className='py-2.5'>
          <div className='mb-2'>
            <Toggle
              on={isDisabled ? false : value}
              disabled={isDisabled}
              onToggle={() => {
                onChange({ team_event: { live_stream_enabled: !value } });
              }}
            />
          </div>
          <Text h='400' color='gray-500'>
            {value
              ? 'Enabled: observers will get a private observation room link'
              : 'Disabled: observer event will have a link to the call with the participant and moderator'}
          </Text>
          {isDisabled && (
            <Text h='400' color='gray-500' className='mt-1'>
              {disabledFeatures.livestream
                ? 'Live streaming is disabled at the account level'
                : study?.focus_group
                  ? 'Live streaming is not available for focus groups'
                  : 'Live streaming is only available for supported video providers'}
            </Text>
          )}
        </div>
      )}
    </FieldRow>
  );
};
